<asw-error-guidance-pres
  [errorInfo]="errorInfo$ | async"
  [displayErrorKey]="displayErrorKey$ | async"
></asw-error-guidance-pres>
